import type { AlienRuleSection } from './types';

export const outbreakSections: AlienRuleSection[] = [
  {
    "id": "ai:outbreak:overview",
    "scenarioId": "outbreak",
    "title": "Opis trybu",
    "summary": "Pełna kooperacja. Drużyna walczy z epidemią i nie śledzi OP.",
    "bullets": [
      "2–4 graczy",
      "Poziom trudności źródłowy: trudny"
    ]
  },
  {
    "id": "ai:outbreak:components",
    "scenarioId": "outbreak",
    "title": "Komponenty",
    "bullets": [
      "Nakładka toru czasu",
      "Znacznik czasu",
      "Mikrobiolog i jego karta",
      "4 projekty szpitali",
      "10 kafli odkryć",
      "4 nagrody LSS",
      "16 kart infekcji",
      "Technologia medycyny",
      "7 szpitali",
      "15 leków",
      "4 szczepionki",
      "6 misji rozdziału 2",
      "dwustronna karta limitu 12/14"
    ]
  },
  {
    "id": "ai:outbreak:setup",
    "scenarioId": "outbreak",
    "title": "Przygotowanie",
    "steps": [
      "Usuń podstawowe kafle odkryć, znaczniki postępu i OP, planszę naukowców i kontraktów, podstawowych naukowców, kontrakty, nagrody LSS, misje oraz prywatne cele 13 i 15.",
      "W magazynie zamiast kryształów połóż 2 leki; trzecie pole pozostaje puste.",
      "Dodaj 2 nowe projekty poziomu 1 na wierzch talii poziomu 1 i 2 nowe projekty poziomu 3 na wierzch części poziomu 3.",
      "Każdy rząd ekspozycji projektów ma 7 kart.",
      "Technologię medycyny połóż na projekcie Disease Control Clinic.",
      "Mikrobiologa połóż obok ekspozycji budynków; jego koszt to 2 leki.",
      "Dołóż stos szpitali.",
      "Wylosuj jedną czerwoną i jedną niebieską misję.",
      "Kartę limitu infekcji połóż stroną 14; trudniejszy wariant używa 12.",
      "Tor czasu połóż stroną 12.",
      "Znacznik czasu ustaw: 2 graczy—12, 3—10, 4—8.",
      "Potasuj talię infekcji."
    ]
  },
  {
    "id": "ai:outbreak:victory",
    "scenarioId": "outbreak",
    "title": "Warunki zwycięstwa i porażki",
    "bullets": [
      "Wygrana natychmiast po ukończeniu obu misji, jeżeli zakażonych jest mniej niż limit 12/14.",
      "Porażka, gdy zakażonych jest 12/14 kolonistów.",
      "Porażka, gdy zakażeni są wszyscy aktualnie aktywni koloniści.",
      "Porażka, gdy czas miałby spaść z 1 na 0."
    ]
  },
  {
    "id": "ai:outbreak:infection-draw",
    "scenarioId": "outbreak",
    "title": "Dobieranie karty infekcji",
    "steps": [
      "Poza rundą 1, na początku tury odkryj kartę infekcji.",
      "Jeśli karta wskazuje dwa miejsca, wybierz stojącego, niezaszczepionego kolonistę w jednym z nich i połóż go.",
      "Jeśli nie ma odpowiedniego kolonisty, wybierz kolonistę w dowolnych kwaterach.",
      "Jeśli karta pokazuje No Infection, nikt nie choruje.",
      "Gdy obie karty No Infection są odkryte, potasuj całą talię.",
      "Aktywny gracz może teraz jednorazowo przeorganizować kolonistów we własnych kwaterach."
    ]
  },
  {
    "id": "ai:outbreak:infected-colonists",
    "scenarioId": "outbreak",
    "title": "Zakażeni koloniści",
    "bullets": [
      "Leżący kolonista jest zakażony.",
      "Zakażony nadal liczy się do dodatkowego kosztu pól akcji.",
      "Na końcu tury zakaża wszystkich kolonistów współdzielących ten sam obszar roboczy, pole akcji, komórkę kwater lub początkowe miejsce.",
      "Zakażenie nie przechodzi pomiędzy różnymi obszarami."
    ]
  },
  {
    "id": "ai:outbreak:medicine",
    "scenarioId": "outbreak",
    "title": "Lek",
    "bullets": [
      "W dowolnym momencie własnej tury wydaj 1 lek, aby postawić dowolnego zakażonego kolonistę.",
      "Nie musi to być twój kolonista.",
      "Limit przechowywania leków wynosi 1 + liczba twoich schronów."
    ]
  },
  {
    "id": "ai:outbreak:hospitals",
    "scenarioId": "outbreak",
    "title": "Budowa szpitali",
    "bullets": [
      "Pierwszy szpital musi sąsiadować z jednym z twoich schronów.",
      "Kolejne szpitale buduje się według normalnych reguł.",
      "Koszt szpitala: 1 minerał.",
      "Szpitale produkują leki.",
      "Podczas uzupełniania kolonii lewa kolumna magazynu ma zostać uzupełniona do 2 leków."
    ]
  },
  {
    "id": "ai:outbreak:advanced-buildings",
    "scenarioId": "outbreak",
    "title": "Zaawansowane szpitale",
    "bullets": [
      "Disease Control Clinic: rozwiń technologię medycyny o 1; tę technologię rozwija się tylko przez tę akcję albo użycie jej przez innego gracza.",
      "Microbiology Lab: zapłać dodatkowo 2 kryształy, aby wyprodukować 1 lek.",
      "Pharmacy: wyprodukuj 1 lek.",
      "Vaccination Center: wyprodukuj szczepionkę i umieść ją pod dowolnym kolonistą; kolonista wstaje i staje się odporny."
    ]
  },
  {
    "id": "ai:outbreak:end-turn",
    "scenarioId": "outbreak",
    "title": "Koniec tury",
    "paragraphs": [
      "Wszyscy koloniści dzielący miejsce z zakażonym kolonistą zostają zakażeni i są kładzeni. Sprawdzenie następuje po zakończeniu wszystkich działań gracza."
    ]
  },
  {
    "id": "ai:outbreak:shuttle",
    "scenarioId": "outbreak",
    "title": "Faza wahadłowca",
    "paragraphs": [
      "Na początku fazy wahadłowca zmniejsz znacznik czasu o 1."
    ]
  },
  {
    "id": "ai:outbreak:missions",
    "scenarioId": "outbreak",
    "title": "Możliwe cele misji",
    "bullets": [
      "Rozwiń technologię medycyny do końca.",
      "Posiadaj 2 szczepionki.",
      "Posiadaj 5 leków.",
      "Ulepsz 3 szpitale.",
      "Wybuduj 5 szpitali.",
      "Posiadaj wszystkie 4 projekty szpitali, niezależnie od ich zbudowania."
    ]
  }
];
